{
  "version": 1,
  "asset_id": "487fd32b-67cb-4598-a92f-d620ab2192f3",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/487fd32b-67cb-4598-a92f-d620ab2192f3/aleph-soybean-field.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/487fd32b-67cb-4598-a92f-d620ab2192f3/aleph-soybean-field.webp",
  "original_filename": "aleph-soybean-field.webp",
  "size": 369156,
  "content_type": "image/webp",
  "created_at": "2026-10-06T20:08:47Z"
}
